(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/match-ticker/assets/javascripts/match-ticker-dev-panel.js') >= 0) return;  svs.modules.push('/widgets/match-ticker/assets/javascripts/match-ticker-dev-panel.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const EventState = svs.components.oddset.kambiOffering.common.constants.EventState;

const setIsLive = (eventId, override) => {
  const event = svs.widget.match_ticker.instance.events.find(e => e.id === eventId);
  if (event) {
    event.state = (override === null || override === void 0 ? void 0 : override.state) === undefined ? EventState.STARTED : override.state;
    svs.widget.match_ticker.instance.onLiveDataUpdate(event);
  }
};

const updateScore = (eventId, override) => {
  const event = svs.widget.match_ticker.instance.events.find(e => e.id === eventId);
  if (event) {
    var _override$score, _override$score2;
    event.score = {
      home: (override === null || override === void 0 || (_override$score = override.score) === null || _override$score === void 0 ? void 0 : _override$score.home) || Math.floor(Math.random() * 100),
      away: (override === null || override === void 0 || (_override$score2 = override.score) === null || _override$score2 === void 0 ? void 0 : _override$score2.away) || Math.floor(Math.random() * 5)
    };
    svs.widget.match_ticker.instance.onLiveDataUpdate(event);
  }
};
const updateSingleEvent = (eventId, override) => {
  setIsLive(eventId, override);
  updateScore(eventId, override);
};
const updateEverything = () => svs.widget.match_ticker.instance.events.forEach(event => updateSingleEvent(event.id));
const repeatUpdateEverything = () => setTimeout(() => {
  clearTimeout(repeatUpdateEverything);
  repeatUpdateEverything();
  svs.widget.match_ticker.instance.events.forEach(event => updateSingleEvent(event.id));
  return repeatUpdateEverything;
}, 1000);
const devPanel = () => {
  if (!svs.core.detect.feature('ft-oddset-ticker-debug-tools')) {
    return;
  }
  const element = document.createElement('div');
  element.innerHTML = svs.widget.match_ticker.templates.match_ticker_dev_panel();
  const body = document.querySelector('body');
  const panelEl = element.firstChild;
  body.appendChild(panelEl);
  panelEl.querySelector('#updateAllMatch').addEventListener('click', () => {
    const statusText = document.querySelector('#statusText');
    statusText.innerHTML = '...';
    updateEverything();
    setTimeout(() => {
      statusText.innerHTML = 'Updated everything';
    }, 100);
  });
  panelEl.querySelector('#repeatUpdateAllMatch').addEventListener('click', () => {
    const statusText = document.querySelector('#statusText');
    statusText.innerHTML = '...';
    repeatUpdateEverything();
    setTimeout(() => {
      statusText.innerHTML = 'Updated everything';
    }, 100);
  });
  panelEl.querySelector('#updateSingleMatch').addEventListener('click', () => {
    const eventIdRaw = document.querySelector('#matchId').value;
    if (!eventIdRaw) {
      return;
    }
    const statusText = document.querySelector('#statusText');
    statusText.innerHTML = '...';
    const eventId = parseInt(eventIdRaw, 10);
    const homeScore = parseInt(document.querySelector('#homeScore').value, 10) || 0;
    const awayScore = parseInt(document.querySelector('#awayScore').value, 10) || 0;
    const isLive = document.querySelector('#isLive').checked;
    let override = {};
    if (homeScore || awayScore) {
      override = {
        score: {
          home: homeScore,
          away: awayScore
        }
      };
    }
    override = _objectSpread(_objectSpread({}, override), {}, {
      state: isLive ? EventState.STARTED : EventState.NOT_STARTED
    });
    updateSingleEvent(eventId, override);
    setTimeout(() => {
      statusText.innerHTML = "Updated event ".concat(eventId);
    }, 100);
  });
};
setGlobal('svs.widget.match_ticker.setUpDevPanel', devPanel);

 })(window);